//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as api from "@/api/overseasChinese/overseasChinese";
export default {
  data: function data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        classDate: "",
        classTime: "",
        classnames: "",
        classrooms: "",
        count: "",
        day: "",
        knob: "",
        name: "",
        teachers: "",
        timeType: "",
        week: ""
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      var _JSON$parse = JSON.parse(this.$route.query.info),
          day = _JSON$parse.day,
          pkteachclassid = _JSON$parse.pkteachclassid,
          timeType = _JSON$parse.timeType,
          week = _JSON$parse.week,
          termid = _JSON$parse.termid;

      api.selectKbDetails({
        day: day,
        pkteachclassid: pkteachclassid,
        timeType: timeType,
        week: week,
        semesterId: termid
      }).then(function (res) {
        if (res.data.code == 0) {
          _this.formLabelAlign = res.data.data;
        }
      });
    },
    formatV: function formatV(value) {
      var newVal;

      switch (value) {
        case "1":
          newVal = "星期一";
          break;

        case "2":
          newVal = "星期二";
          break;

        case "3":
          newVal = "星期三";
          break;

        case "4":
          newVal = "星期四";
          break;

        case "5":
          newVal = "星期五";
          break;

        case "6":
          newVal = "星期六";
          break;

        case "7":
          newVal = "星期天";
          break;
      }

      return newVal;
    }
  }
};